

import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import avatar from "../../images/img/avatar.jpg";
import getPastDateAndTime from "../../helper/date/getPastDateAndTime";
import { setSelectUserData } from "../../features/user/userSlice";
import { showNestedModal } from "../../features/modal/modalSlice";
import { setHoveredUser } from "../../features/branchUserLocations/branchUserLocationsSlice";

const Container = styled.div`
  position: absolute;
  top: ${({ topData }) => topData + "px"};
  left: ${({ leftData }) => leftData + "px"};
  transform: translate(-50%, -100%);
  background-color: #fff;
  color: #000;
  padding: 5px;
  border-radius: 8px;
  pointer-events: auto;
  z-index: 9999;
  border-bottom: 3px solid var(--color-main);
  display: flex;
  align-items: center;
  width: auto;
  height: auto;
  user-select: none;

  .left-side {
    padding: 10px;

    img{
      width: 100px;
      height: 100px;
      border-radius: 50%;
      object-fit: cover;
      border: 2px solid var(--color-main);
    }

  }

  .right-side {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: auto;
    padding: 5px;
    padding-left: 15px;

    .username {
      font-size: var(--font-size-sm);
      font-weight: var(--font-weight-lg);
    }

    .phone-number {
      font-size: 12px;
      font-weight: var(--font-weight-lg);
    }

    .last-time{
      font-size: 12px;
      font-weight: var(--font-weight-lg);

    }

    .bottom-container{
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 60px;

      .version{
        font-size: 12px;
        font-weight: var(--font-weight-lg);

      }

      .button{
        text-decoration: underline;
        color: var(--color-main);
        font-size: 12px;
        font-weight: var(--font-weight-lg);
      }
    }

  }
`;

const UserOverlay = ({ hoverTimeout }) => {
  const dispatch = useDispatch();
  const { hoveredUser } = useSelector((state) => state.branchUserLocations);

  const {isListView} = useSelector(state => state.branchUserLocations)

  const handleOverlayMouseEnter = (e) => {
    if (hoverTimeout.current) clearTimeout(hoverTimeout.current);
    e.stopPropagation();
  };

  const handleOverlayMouseLeave = (e) => {
    e.stopPropagation();
    dispatch(setHoveredUser(null));
  };

  

  if (!hoveredUser) return null;

  return (
    <Container
      topData={hoveredUser.y - 10}
      leftData={isListView ? hoveredUser.x - 190 : hoveredUser.x}
      onMouseEnter={handleOverlayMouseEnter}
      onMouseLeave={handleOverlayMouseLeave}
    >
      <div className="left-side">
        <img
          src={
            hoveredUser.profilePhoto
              ? `${process.env.REACT_APP_API_IMG_URI}${hoveredUser.profilePhoto}`
              : avatar
          }
          alt=""
        />
      </div>
      <div className="right-side">
        <div className="username">{hoveredUser?.adSoyadUnvan}</div>
        <div className="phone-number">{hoveredUser?.phoneNumber}</div>
        <div className="last-time">Son Konum Alma: {getPastDateAndTime(hoveredUser.konumSonGorulme).formattedDate} {getPastDateAndTime(hoveredUser.konumSonGorulme).formattedTime}</div>
        <div className="bottom-container">
        <div className="version">Sürüm: {hoveredUser.appVersionNumber}</div>
        <button className="button" onClick={() => {dispatch(showNestedModal("surucuProfil")); dispatch(setSelectUserData(hoveredUser.phoneNumber))}}>Profili Görüntüle</button>

        </div>
      </div>
    </Container>
  );
};

export default UserOverlay;
